<script type="ts">
  import { store } from "../store";
  import GameCard from "./game_card/GameCard.svelte";
  import Cards from "svelte-material-icons/Cards.svelte";
</script>

{#if $store.length === 0}
  <div class="mt-20 text-center text-gray-600">
    <Cards width="150" height="150" class="block m-auto"/>
    <h2 class="m-4 text-2xl font-bold">Es gibt noch keine vergangnen Runden</h2>
    <p class="m-4">Klicke auf den Button unten, um eine neue zu starten.</p>
  </div>
{/if}

{#each $store as game (game.id)}
  <div>
    <GameCard {game} />
  </div>
{/each}
